<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <ion-header class="transparent">
            <app-header class="dark-mode"
                        [middleIcon]="userService.companyLogo !== 'assets/icon/journey-logo.svg'"
                        [middleIconSize]="userService.companyLogoSize"
                        [backIconWork]="false" [@enter]>
            </app-header>
        </ion-header>

        <div class="bg bg-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform == 'mobile'}" [@enter]>
        </div>
        <div class="box content-wrap" [@enter] *ngIf="userInfo !== null">
            <div class="title">
                {{'__HOME_HI__' | translate}} {{userInfo.first_name}}
                <div *ngIf="userType !== 'coach'" class="welcome-text desktop-only">{{'__HOME_WELCOME_TO_MY721__' | translate}}</div>
                <div *ngIf="userType === 'coach'" class="welcome-text desktop-only">{{'__HOME_COACH_WELCOME_TO_MY721__' | translate}}</div>
                <div *ngIf="userType !== 'coach'" class="welcome-text mobile-only">{{'__HOME_WELCOME_TO_MY721__' | translate}}</div>
                <div *ngIf="userType === 'coach'" class="welcome-text mobile-only">{{'__HOME_COACH_WELCOME_TO_MY721__' | translate}}</div>
            </div>
            <div *ngIf="userType !== 'coach'" class="text">{{'__HOME_WELCOME_INTRO_TEXT__' | translate}}</div>
            <div *ngIf="false && userType === 'coach'" class="text">{{'__HOME_COACH_WELCOME_INTRO_TEXT__' | translate}}</div>
            <div class="small copyright">
                &copy; {{'__HOME_COPYRIGHT_TEXT__' | translate}} {{'__HOME_VERSION__' | translate}} {{authService.appVersion}}{{environment.appVersionSuffix}}
                <div class='link' (click)="goToLink('https://thisisalchemist.com/privacy-policy-2/')">{{'__HOME_INSPIRE_PRIVACY_POLICY__' | translate}}</div>
            </div>
        </div>
        <div class="box" *ngIf="userInfo === null"></div>
        <div class="shadow-container">
            <app-delegate-home *ngIf="userType && userType !== 'coach'" [progress]="progress" [userInfo]="userInfo"></app-delegate-home>
            <app-coach-home *ngIf="userType && userType === 'coach'" [progress]="progress" [userInfo]="userInfo"></app-coach-home>

            <ion-footer *ngIf="menuVisible && userType && userType !== 'coach'" slot="fixed" [@enterUp]>
                <app-footer [forAdmin]="(authService.getUserType() === 'manager')" [level]="'learner'"
                    [progress]="progress" currentPage="home"></app-footer>
            </ion-footer>
        </div>
        <app-footer-logo></app-footer-logo>
    </div>
</ion-content>
